import { render, staticRenderFns } from "./Roentgenography.vue?vue&type=template&id=693d8f64&scoped=true"
import script from "./Roentgenography.vue?vue&type=script&lang=js"
export * from "./Roentgenography.vue?vue&type=script&lang=js"
import style0 from "./Roentgenography.vue?vue&type=style&index=0&id=693d8f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693d8f64",
  null
  
)

export default component.exports